module.exports = __webpack_public_path__ + "static/media/uygulama-removebg-preview.487b1446.png";